import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { IntlPropType } from "root/libs/core-libs/src";
import { notifyIssue } from "../../../monitoring/notifyIssue";
import { NoOffersResponse } from "../NoOffersCard";

const EmptyOffers = ({
  haveTheBackendsErrors,
  intl,
  backToShipmentLaneReference,
  shareUrl,
}) => {
  useEffect(() => {
    notifyIssue({
      shareUrl,
      apiError: haveTheBackendsErrors,
    });
  }, []);

  return (
    <NoOffersResponse
      backToShipmentLaneReference={backToShipmentLaneReference}
      intl={intl}
    />
  );
};

EmptyOffers.propTypes = {
  intl: IntlPropType.isRequired,
  haveTheBackendsErrors: PropTypes.bool,
  /** Additional key to look up and display specific message variations */
  backToShipmentLaneReference: PropTypes.object,
  shareUrl: PropTypes.string,
};

EmptyOffers.defaultProps = {
  haveTheBackendsErrors: false,
  backToShipmentLaneReference: React.createRef(),
};

export default injectIntl(EmptyOffers);
